import SideMenu from "./sideMenu";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useEffect, useState } from "react";
import config from "../../config";
import { useSelector } from "react-redux";
import QueryString from "query-string";
import { Modal, Form, Spinner } from "react-bootstrap";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import CryptoJS from "crypto-js/aes";
import Utf8 from "crypto-js/enc-utf8";
import MaterialTable, { MTableToolbar } from "material-table";
import { TablePagination } from "@material-ui/core";
import { tableIcons } from "../../tableIcons";
import { Checkbox } from "@material-ui/core";
import FormGroup from "@material-ui/core/FormGroup";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, Space, Typography, Button, Alert } from "antd";
import CustomTable from "../table";
import { useCountry, useCurrency } from "../../provider/courtryProvider";
import { useAccess } from "../../provider/AccessProvider";
import { CUSTOMERACCESS } from "../../utils/constant";

const CustomerBillHistory = (props) => {
  const [shopId, setShopId] = useState("");
  const country = useCountry();
  const merchantId = useSelector((state) => state.shopDetails.shopId);
  const employeeId = useSelector((state) => state.shopDetails.empId);
  const [customerPhoneNumber, setCustomerPhoneNumber] = useState("");
  const [bills, setBills] = useState([]);
  const [invoiceDetails, setInvoiceDetails] = useState([]);
  const [pdf, setPdf] = useState("");
  const [pdfModal, setPdfModal] = useState(false);
  const [billConfirm, setBillConfirm] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [billLoading, setBillLoading] = useState(false);
  const [balanceAmount, setBalanceAmount] = useState(0);
  const [amountReceived, setAmountReceived] = useState("");
  const [pendingAmount, setPendingAmount] = useState(0);
  const [cardType, setCardType] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [billId, setBillId] = useState("");
  const [fullyPaid, setFullyPaid] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const currencyFormatter = useCurrency();
  const location = useLocation();
  const navigate = useNavigate();
  const access = useAccess(CUSTOMERACCESS);
  useEffect(() => {
    var rAmount = amountReceived;
    if (!rAmount) rAmount = 0;
    var total = (parseFloat(balanceAmount) - parseFloat(rAmount)).toFixed(2);
    setPendingAmount(total);
  }, [amountReceived]);

  useEffect(() => {
    if (merchantId === "") return;
    let params = QueryString.parse(location.search);
    const bytes = CryptoJS.decrypt(
      params.id
        .replace(/p1L2u3S/g, "+")
        .replace(/s1L2a3S4h/g, "/")
        .replace(/e1Q2u3A4l/g, "="),
      process.env.REACT_APP_CRYPTO_KEY
    );
    const decrypt = bytes.toString(Utf8);
    setCustomerPhoneNumber(decrypt);
    setShopId(merchantId);
  }, [merchantId]);

  useEffect(() => {
    if (shopId) getBillData(shopId);
  }, [shopId]);

  useEffect(() => {
    getInvoiceDetails();
  }, [bills]);

  const getBillData = async (userId) => {
    try {
      var res = await fetch(
        `${config.newApiGateway}/customer/getCustomerBillDetails`,
        {
          method: "POST",
          body: JSON.stringify({
            phoneNumber: customerPhoneNumber,
            shopId: userId,
          }),
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
        }
      );
      res = await res.json();
      setIsLoading(false);
      if (res.code === "ERROR") return alert(res.message);
      else {
        if (res !== undefined) {
          if (res.limitExceeds && res.status) {
            try {
              var s3Bills = await fetch(res.data);
              s3Bills = await s3Bills.json();

              const filteredBillData = s3Bills.filter((i) => {
                return i.type === "bill";
              });
              setBills(filteredBillData);
              return;
            } catch (err) {
              alert("Failed to fetch Customer bills.");
              return;
            }
          }
          const filteredBillData = res.data.filter((i) => {
            return i.type === "bill";
          });
          setBills(filteredBillData);
          setIsLoading(false);
        }
      }
    } catch (err) {
      console.log("Err", err);
    }
  };

  const getInvoiceDetails = () => {
    let tempBillArray = bills
      .map((data) => {
        return {
          billId: data.billId,
          billingDate: data.billingDate,
          invoiceNumber: data.invoicePrefix
            ? data.invoicePrefix + data.invoiceNumber.toString()
            : data.invoiceNumber.toString(),
          customerName: data.customerName,
          customerPhoneNumber: data.customerPhoneNumber,
          amountPaid: data.amountPaid,
          balanceAmount:
            parseFloat(data.balanceAmount) > 0
              ? parseFloat(data.balanceAmount)
              : 0,
        };
      })
      .sort((a, b) => {
        if (new Date(a.billingDate) < new Date(b.billingDate)) return 1;
        if (new Date(a.billingDate) > new Date(b.billingDate)) return -1;
        if (new Date(a.billingDate) === new Date(b.billingDate)) {
          if (a.invoiceNumber < b.invoiceNumber) return 1;
          if (a.invoiceNumber > b.invoiceNumber) return -1;
          return 0;
        }
      });
    setInvoiceDetails(tempBillArray);
  };

  useEffect(() => {
    if (fullyPaid) setAmountReceived(balanceAmount);
  }, [fullyPaid]);

  const getInvoicePDF = async (billId) => {
    await Promise.all([
      fetch(`${config.newApiGateway}/bill/getInvoice`, {
        method: "POST",
        body: JSON.stringify({
          billId: billId,
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        const arr = new Uint8Array(data.Body.data);
        const blob = new Blob([arr], { type: "application/pdf" });
        const file = URL.createObjectURL(blob);
        setPdf(file);
        setPdfModal(true);
      })
      .catch((err) => {
        console.log("Err", err);
      });
  };

  const payBalanceHandler = (data) => {
    setBalanceAmount(data.balanceAmount);
    setPendingAmount(data.balanceAmount);
    setBillConfirm(true);
    setBillId(data.billId);
  };

  const updateBillBalance = async () => {
    if (!amountReceived) return alert("Please enter amount received.");
    if (parseFloat(amountReceived) <= 0)
      return alert("Amount received should be greater than zero.");
    if (!paymentMethod) return alert("Please choose mode of payment.");
    if (paymentMethod === "card" && !cardType)
      return alert("Please select card type.");
    if (paymentMethod === "card" && !cardNumber)
      return alert("Please enter last four digit card number.");
    setBillLoading(true);
    try {
      var res = await fetch(`${config.newApiGateway}/tools/clearCredits`, {
        method: "POST",
        body: JSON.stringify({
          billId: billId,
          balanceAmount: balanceAmount,
          amountPaid: amountReceived,
          paymentMethod: paymentMethod,
          cardNumber: cardNumber,
          cardType: cardType,
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      });
      res = await res.json();
      if (res.code === "ERROR") {
        console.log("Res", res);
        setBillLoading(false);
        return alert(res.message);
      }
      if (res.code === "SUCCESS") {
        getBillData(shopId);
        resetToDefault();
      }
    } catch (err) {
      console.log("Err", err);
      setBillLoading(false);
      alert("Error while update balance. Please try again.");
    }
  };

  const resetToDefault = () => {
    setBillConfirm(false);
    setBillLoading(false);
    setBalanceAmount(0);
    setAmountReceived("");
    setPendingAmount(0);
    setPaymentMethod("");
    setCardNumber("");
    setCardType("");
    setBillId("");
  };

  function PatchedPagination(props) {
    const {
      ActionsComponent,
      onChangePage,
      onChangeRowsPerPage,
      ...tablePaginationProps
    } = props;

    return (
      <TablePagination
        {...tablePaginationProps}
        // @ts-expect-error onChangePage was renamed to onPageChange
        onPageChange={onChangePage}
        // rowsPerPageOptions={["20", "50", "100", "500"]}
        onRowsPerPageChange={onChangeRowsPerPage}
        ActionsComponent={(subprops) => {
          const { onPageChange, ...actionsComponentProps } = subprops;
          return (
            // @ts-expect-error ActionsComponent is provided by material-table
            <ActionsComponent
              {...actionsComponentProps}
              onChangePage={onPageChange}
            />
          );
        }}
      />
    );
  }

  const tableColumns = [
    {
      title: "Date",
      dataIndex: "billingDate",
    },
    {
      title: "Invoice Number",
      dataIndex: "invoiceNumber",
      defaultSort: "desc",
    },
    {
      title: `Bill Amount(${country.CurrencySymbol})`,
      dataIndex: "amountPaid",
    },
    {
      title: `Balance Amount(${country.CurrencySymbol})`,
      dataIndex: "balanceAmount",
      render: (data) => {
        return <span>{parseFloat(data).toFixed(2)}</span>;
      },
    },
    {
      title: "Actions",
      render: (data) => {
        return (
          <>
            <Button
              type="link"
              onClick={() => {
                getInvoicePDF(data.billId);
              }}
            >
              View
            </Button>{" "}
          </>
        );
      },
    },
  ];

  const exportHead = [
    "Date",
    "Invoice Number",
    "Bill Amount",
    "Balance Amount",
  ];
  const exportValue = [
    "billingDate",
    "invoiceNumber",
    "amountPaid",
    "balanceAmount",
  ];

  if (!access.customerViewAllBills(false)) {
    <Alert
      style={{
        padding: "20px",
        textAlign: "center",
      }}
      message="You don't have access, Please contact your administrator to request the appropriate access."
      type="error"
    />;
  }

  return (
    <div>
      <div>
        <div>
          <Card
            bodyStyle={{
              display: "flex",
              alignItems: "center",
              width: "100%",
            }}
            style={{
              marginBottom: 20,
            }}
          >
            <Space direction="vertical">
              <Typography.Title
                style={{
                  margin: 0,
                }}
                level={5}
              >
                Name:{" "}
                <Typography.Text
                  style={{
                    textTransform: "capitalize",
                  }}
                  type="secondary"
                >
                  {invoiceDetails[0] !== undefined
                    ? invoiceDetails[0].customerName
                    : ""}
                </Typography.Text>
              </Typography.Title>
              <Typography.Title
                style={{
                  margin: 0,
                }}
                level={5}
              >
                Mobile Number:{" "}
                <Typography.Text type="secondary">
                  {invoiceDetails[0] !== undefined
                    ? invoiceDetails[0].customerPhoneNumber
                    : 0}
                </Typography.Text>
              </Typography.Title>
            </Space>
          </Card>
          <CustomTable
            columns={tableColumns}
            title={"Bill History"}
            data={invoiceDetails}
            loading={isLoading}
            excelExport={true}
            exportHead={exportHead}
            exportValue={exportValue}
            csvAccessKey="viewAllBillsExport"
          />
          {/* <div> */}
          {/* <MaterialTable
              data={invoiceDetails}
              columns={[
                {
                  title: "Date",
                  dataIndex: "billingDate",
                },
                {
                  title: "Invoice Number",
                  field: "invoiceNumber",
                  defaultSort: "desc",
                },
                {
                  title: `Bill Amount(${country.CurrencySymbol})`,
                  field: "amountPaid",
                },
                {
                  title: `Balance Amount(${country.CurrencySymbol})`,
                  field: "balanceAmount",
                },
                {
                  title: "Actions",
                  render: (data) => {
                    return (
                      <>
                        <Button
                          onClick={() => {
                            getInvoicePDF(data.billId);
                          }}
                        >
                          View
                        </Button>{" "}
                        {parseInt(data.balanceAmount) > 0 && (
                          <Button
                            onClick={() => {
                              payBalanceHandler(data);
                            }}
                          >
                            Pay
                          </Button>
                        )}
                      </>
                    );
                  },
                },
              ]}
              title="Bill History"
              icons={tableIcons}
              isLoading={isLoading}
              options={{
                pageSize: 10,
                emptyRowsWhenPaging: true,
                pageSizeOptions: [10, 20, 50, 100, 500],
              }}
              components={{
                Pagination: PatchedPagination,
              }}
            /> */}
          {/* </div> */}
        </div>
      </div>
      <Modal
        dialogClassName="custom-pdf-modal"
        show={pdfModal}
        onHide={() => {
          setPdfModal(false);
        }}
      >
        <Modal.Body>
          <div style={{ height: "200px !important" }}>
            <embed
              src={pdf}
              style={{ height: "580px", width: "500px" }}
              type="application/pdf"
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              setPdfModal(false);
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={billConfirm}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body style={{ padding: 0 }}>
          <div className="billConfirmModalContainer">
            <div className="billConfirmLeftContainer">
              <p className="totalAmountStyle">Balance Amount</p>
              <p className="priceStyle">{currencyFormatter(balanceAmount)}</p>
              <FormGroup
                style={{
                  marginLeft: "20px",
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={fullyPaid}
                      onChange={() => {
                        setFullyPaid(!fullyPaid);
                      }}
                    />
                  }
                  label="Full amount received"
                />
              </FormGroup>
            </div>
            <div className="billConfirmRightContainer">
              <p className="recievedTextStyle">Amount Received</p>
              <input
                className="amountStyle"
                onChange={(e) => setAmountReceived(e.target.value)}
                value={fullyPaid ? balanceAmount : amountReceived}
                disabled={fullyPaid}
                type="number"
              />
              <div style={{ height: 25 }}></div>
              <p className="recievedTextStyle">
                {pendingAmount >= 0 ? (
                  <>Pending Amount</>
                ) : pendingAmount < 0 ? (
                  <>Remaining Amount</>
                ) : (
                  <></>
                )}
              </p>
              <p className="discountStyle">
                {pendingAmount > 0 ? (
                  <>{currencyFormatter(pendingAmount)}</>
                ) : pendingAmount <= 0 ? (
                  <>{currencyFormatter(pendingAmount)}</>
                ) : (
                  <></>
                )}
              </p>
            </div>
          </div>
          <div
            className="paymentDetails"
            style={{ margin: "10px 0px 0px 20px" }}
          >
            <div className="paymentDetails-name">
              <p>Payment Method</p>
            </div>
            <div className="paymentDetails-group">
              <RadioGroup
                row
                aria-label="gender"
                name="methods"
                className="group"
                style={{ fontSize: 13, marginTop: -5, marginLeft: 5 }}
              >
                <FormControlLabel
                  value="cash"
                  control={<Radio style={{ color: "#5194c6" }} />}
                  label="Cash Amount"
                  onClick={() => setPaymentMethod("cash")}
                  checked={paymentMethod === "cash"}
                />
                <FormControlLabel
                  value="upi"
                  control={<Radio style={{ color: "#5194c6" }} />}
                  label="UPI Pay"
                  onClick={() => setPaymentMethod("upi")}
                  checked={paymentMethod === "upi"}
                />
                <FormControlLabel
                  value="card"
                  control={<Radio style={{ color: "#5194c6" }} />}
                  label="Debit/Credit"
                  onClick={() => setPaymentMethod("card")}
                  checked={paymentMethod === "card"}
                />
              </RadioGroup>
            </div>
          </div>
          <div>
            {paymentMethod === "card" && (
              <div
                className="billConfirmCardRightContainer"
                style={{
                  marginBottom: "20px",
                }}
              >
                <p className="paymentDetails-name">Card Details</p>
                <p className="cardTypeText">Card Type</p>
                <Form.Control
                  as="select"
                  value={cardType}
                  onChange={(e) => setCardType(e.target.value)}
                >
                  <option value="">Choose card type</option>
                  <option value="visa">Visa</option>
                  <option value="masterCard">Master Card</option>
                  <option value="rupay">Rupay</option>
                </Form.Control>
                <div style={{ height: 8 }}></div>
                <p className="cardTypeText">Card Number</p>
                <Form.Control
                  value={cardNumber}
                  onChange={(e) => setCardNumber(e.target.value)}
                  type="text"
                  placeholder="Enter last 4 digit number"
                />
              </div>
            )}
          </div>
          {!billLoading ? (
            <div className="rowButton">
              <button
                disabled={billLoading}
                onClick={() => resetToDefault()}
                className="leftButtonStyle"
              >
                Cancel
              </button>
              <button
                disabled={billLoading}
                className="rightButtonStyle"
                onClick={() => updateBillBalance()}
              >
                Confirm
              </button>
            </div>
          ) : (
            <div
              style={{
                textAlign: "center",
                margin: "20px 0px 20px 0px",
              }}
            >
              <Spinner animation="border" variant="secondary" />
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CustomerBillHistory;
